export const FeaturedProductsList = [
    {
        key: 'products',
        title: 'Featured Men’s Lacrosse Products',
        items: [
            {
                title: 'Mark 3A',
                path: '/mens-lacrosse/heads/mark-3a?sku=mark-3a-custom-strung',
                image: 'static/common/images/featured-home/mens-lax/mens-lax-feature-1.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: `StringKing Mark 2F Men's Mark 3A Head`
            },
            {
                title: 'Starter Junior',
                path: '/mens-lacrosse/sticks/starter-junior?sku=starter-junior-mark-jr-starter-junior-custom',
                image: 'static/common/images/featured-home/mens-lax/mens-lax-feature-2.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: 'StringKing Starter Junior Lacrosse Stick'
            },
            {
                title: 'Flyer 1',
                path: '/mens-lacrosse/gloves/flyer-1?sku=flyer-1-l-13-white',
                image: 'static/common/images/featured-home/mens-lax/mens-lax-feature-3.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: 'StringKing Flyer 1 Lacrosse Gloves'
            }
        ]
    },
    {
        key: 'lax_mens_pros',
        title: 'Men\'s Lacrosse Pro Athletes',
        useCarousel: true,
        items: [
            {
                title: 'Chris kavanagh',
                path: '/team-stringking/mens-lacrosse/pro-athletes/chris-kavanagh/',
                image: 'static/common/images/featured-home/lax-mens-pros/chris-kavanagh.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: true,
                imgPosition: 'center -1rem',
                altText: 'Chris kavanagh Profile'
            },
            {
                title: 'Blaze Riorden',
                path: '/team-stringking/mens-lacrosse/pro-athletes/blaze-riorden/',
                image: 'static/common/images/featured-home/lax-mens-pros/blaze-riorden.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: true,
                imgPosition: 'center -1rem',
                altText: 'Blaze Riorden Profile'
            },
            {
                title: 'Brennan O\'Neill',
                path: '/team-stringking/mens-lacrosse/pro-athletes/brennan-oneill/',
                image: 'static/common/images/featured-home/lax-mens-pros/brennan-oneill.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: true,
                imgPosition: 'center -1rem',
                altText: 'Brennan O\'Neill Profile'
            },
            {
                title: 'Tom Schreiber',
                path: '/team-stringking/mens-lacrosse/pro-athletes/tom-schreiber/',
                image: 'static/common/images/featured-home/lax-mens-pros/tom-schreiber.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: true,
                imgPosition: 'center -1rem',
                altText: 'Tom Schreiber Profile'
            },
            {
                title: 'Pat kavanagh',
                path: '/team-stringking/mens-lacrosse/pro-athletes/pat-kavanagh/',
                image: 'static/common/images/featured-home/lax-mens-pros/pat-kavanagh.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: true,
                imgPosition: 'center -1rem',
                altText: 'Pat kavanagh Profile'
            },
            {
                title: 'Curtis dickson',
                path: '/team-stringking/mens-lacrosse/pro-athletes/curtis-dickson/',
                image: 'static/common/images/featured-home/lax-mens-pros/curtis-dickson.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: true,
                imgPosition: 'center -1rem',
                altText: 'Curtis dickson Profile'
            }
        ]
    },
    {
        key: 'w_products',
        title: 'Featured Women’s Lacrosse Products',
        items: [
            {
                title: 'Complete 2 Pro',
                path: '/womens-lacrosse/sticks/womens-complete-2-pro-offense/',
                image: '/static/common/images/featured-home/womans-lacrosse/1-womens-complete-2-pro-offense-tech-trad_sm.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: `StringKing Women's Complete 2 Pro Lacrosse Stick Featured Product`
            },
            {
                title: 'Complete',
                path: '/womens-lacrosse/sticks/womens-complete/',
                image: '/static/common/images/featured-home/womans-lacrosse/2--womens-complete-tech-trad_sm.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: `StringKing Women's Complete Lacrosse Stick Featured Product`
            },
            {
                title: 'Starter',
                path: '/womens-lacrosse/sticks/girls-starter/',
                image: '/static/common/images/featured-home/womans-lacrosse/3-womens-starter-type-4_sm.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: `StringKing Women's Starter Lacrosse Stick Featured Product`
            }
        ]
    },
    {
        key: 'featured_baseball',
        title: 'Featured Baseball Bats',
        items: [
            {
                title: 'METAL 2 PRO USSSA BATS',
                path: '/baseball/usssa-baseball-bats/metal-2-pro-usssa/',
                image: 'static/common/images/featured-home/Metal-2-Pro-USSSA-Homepage-Featured.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: 'Baseball Metal 2 Pro USSSA Youth Big Barrel Senior League Bat'
            },
            {
                title: 'METAL 2 PRO BBCOR BATS',
                path: '/baseball/bbcor-baseball-bats/metal-2-pro-bbcor/',
                image: 'static/common/images/featured-home/Metal-2-Pro-BBCOR-Homepage-Featured.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: 'StringKing Metal 2 Pro BBCOR Baseball Bat Featured Product'
            },
            {
                title: 'METAL PRO USA BASEBALL BATS',
                path: '/baseball/usabat-baseball-bats/metal-pro-usabat/',
                image: 'static/common/images/featured-home/StringKing-Baseball-Metal-Pro-USABat-29in-Homepage-Feature-Tag-768x512.jpg',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: 'StringKing Baseball Metal Pro USABat 29in Homepage Feature'
            }
        ]
    },
    {
        key: 'featured_softball',
        title: 'Featured Softball Bats',
        items: [
            {
                title: 'METAL PRO FASTPITCH -10 BATS',
                path: '/softball/fastpitch-softball-bats/metal-pro-fastpitch',
                image: 'static/common/images/featured-home/Baseball-HomepageArtboard-10@1.6x.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: 'Metal Pro Fastpitch Drop 10 Softball Bat'
            },
            {
                title: 'Metal Pro Fastpitch -11 Bats',
                path: '/softball/fastpitch-softball-bats/metal-pro-fastpitch',
                image: 'static/common/images/featured-home/Baseball-HomepageArtboard-11@1.6x.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: 'Metal Pro Fastpitch Drop 11 Softball Bat'
            },
            {
                title: 'METAL PRO SLOWPITCH BATS',
                path: '/softball/slowpitch-softball-bats/metal-pro-usa-slowpitch',
                image: 'static/common/images/featured-home/Baseball-HomepageArtboard-3@1.6x.webp',
                imageUrl: null,
                imgClass: null,
                imgCover: false,
                imgPosition: null,
                altText: 'Metal Pro Slowpitch Softball Bat'
            }
        ]
    },
    {
        key: 'featured_apparel',
        title: 'Featured Custom-Fit Apparel',
        items: [
            {
                title: 'Men\'s Pima Terry Tee',
                path: '/mens-apparel/t-shirts/mens-pima-terry-tee?sku=mens-pima-terry-tee-relaxed-fit-white',
                image: 'static/common/images/featured-home/custom-fit-apparel/mens-pima-terry-tee-relaxed-fit-white.webp',
                imageUrl: null,
                imgClass: 'sku-img-filter-1',
                imgCover: false,
                imgPosition: null,
                altText: 'StringKing Pima Terry Tee, White'
            },
            {
                title: 'Men\'s Pima Jersey Classic Polo',
                path: '/mens-apparel/polos/mens-pima-jersey-classic-polo?sku=mens-pima-jersey-classic-polo-relaxed-fit-navy',
                image: 'static/common/images/featured-home/custom-fit-apparel/mens-pima-jersey-classic-polo-relaxed-fit-navy.webp',
                imageUrl: null,
                imgClass: 'sku-img-filter-1',
                imgCover: false,
                imgPosition: null,
                altText: 'StringKing Pima Jersey Classic Polo, Navy'
            },
            {
                title: 'Men\'s StayWarm Quarter Zip',
                path: '/mens-apparel/quarter-zips/mens-staywarm-quarter-zip?sku=mens-staywarm-quarter-zip-relaxed-fit-black',
                image: 'static/common/images/featured-home/custom-fit-apparel/mens-staywarm-quarter-zip-relaxed-fit-black.webp',
                imageUrl: null,
                imgClass: 'sku-img-filter-1',
                imgCover: false,
                imgPosition: null,
                altText: 'StringKing StayWarm Quarter Zip, Black'
            }
        ]
    }
];

export const FeaturedVideosList = [
    {
        title: 'Matt Gibson Wall Ball Lacrosse',
        youtubeId: 'rMKupygKYU0',
        thumbnail: 'static/common/images/featured-home/StringKing-Homepage-Video-Lacrosse-480x320-1920x1280.jpg'
    },
    {
        title: 'Behind The Design: The Mark 3V',
        youtubeId: 'T3tipCdiB-U',
        thumbnail: 'static/common/images/featured-home/feature-yt-mark-v3.webp'
    },
    {
        title: '24-hour Custom-Fit Apparel',
        youtubeId: 'vYIs0JaI_yg',
        thumbnail: 'static/common/images/featured-home/StringKing-Homepage-Video-Apparel-480x320-1920x1280.jpg'
    }
];
